import React, { useState, useContext, createContext } from "react"
import { Sun, Moon } from "lucide-react"

export const ThemeContext = createContext({ theme: 'light' });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export const ThemeToggle = () => {



  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-200"
    >
      {theme === 'light' ? (
        <Sun size={20} className="text-yellow-500 transform transition-transform duration-500 rotate-0" />
      ) : (
        <Moon size={20} className="text-blue-300 transform transition-transform duration-500 rotate-0" />
      )}
    </button>
  );
};

export default ThemeToggle
